import React from "react";
import NewProductTemplate from "../../components/sections/product-more-info/Item";
import { cn } from "../../utils/cn";
import Emoji from "../../utils/emoji";

const styles = {
    strong: "font-semibold text-ccyan",
    title: "font-bold text-xl font-montserrat",
    list: "list-disc ml-4",
};

const Product = (props) => {
    const { pageContext } = props;
    const { item } = pageContext;

    const Data = () => {
        return (
            <section className="mx-auto max-w-xl text-left font-inter text-gray-500 lg:max-w-2xl xl:max-w-3xl">
                <h2 className="text-2xl font-semibold text-cpurple">
                    <Emoji
                        symbol="🛡️"
                        label="campus espai bulevard ispc 2026"
                    />{" "}
                    CAMPUS ESPAI BULEVARD — 40a PROMOCIÓ (2026/2027)
                </h2>

                <p className="mt-5">
                    Arriba a l&apos;Institut de Seguretat Pública de Catalunya
                    amb un pas d&apos;avantatge.
                </p>

                <p className="mt-5">
                    Entrar a l&apos;ISPC és un dels moments més importants de la
                    carrera de qualsevol futur policia. Comença una etapa
                    exigent, amb nous procediments, noves dinàmiques i una
                    manera de treballar completament diferent de la preparació
                    de l&apos;oposició.
                </p>

                <p className="mt-5">
                    Des de fa més de 8 anys, a iOpos preparem futurs policies
                    perquè arribin a l&apos;Escola amb coneixements pràctics,
                    confiança i una base sòlida que els permeti adaptar-se molt
                    més ràpidament.
                </p>

                <p className="mt-5">
                    El Campus Espai Bulevard està dissenyat perquè facis aquest
                    pas amb les màximes garanties.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🎯" label="per que campus espai bulevard" />{" "}
                    Per què preparar-te amb l&apos;Espai Bulevard?
                </h2>

                <p className="mt-5">
                    Aquest programa no està pensat per memoritzar teoria, sinó
                    per ajudar-te a viure una experiència molt semblant a la que
                    trobaràs a l&apos;ISPC.
                </p>

                <p className="mt-5">
                    Treballaràs situacions pràctiques, procediments i dinàmiques
                    perquè el primer dia arribis amb més seguretat i menys
                    incertesa.
                </p>

                <p className="mt-5">Amb aquesta preparació aconseguiràs:</p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>Entendre millor el funcionament de l&apos;ISPC.</li>
                    <li>Arribar amb més confiança i menys incertesa.</li>
                    <li>Familiaritzar-te amb les dinàmiques de treball.</li>
                    <li>
                        Desenvolupar habilitats pràctiques abans d&apos;entrar a
                        l&apos;Escola.
                    </li>
                    <li>
                        Aprofitar molt millor els primers mesos de formació.
                    </li>
                </ul>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji
                        symbol="📚"
                        label="que inclou campus espai bulevard"
                    />{" "}
                    Què inclou la formació?
                </h2>

                <p className="mt-5">
                    L&apos;Espai Bulevard combina formació presencial, campus
                    virtual i acompanyament continu perquè puguis preparar-te
                    des de diferents vessants.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🏫" label="formacio presencial ispc" />{" "}
                    Formació presencial
                </h2>

                <p className="mt-5">
                    El programa inclou{" "}
                    <strong>8 sessions presencials de 3 hores</strong>,
                    desenvolupades en grups reduïts per garantir una experiència
                    pràctica, dinàmica i personalitzada.
                </p>

                <p className="mt-5">Durant aquestes sessions treballaràs:</p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>Simulacions pràctiques.</li>
                    <li>Procediments policials.</li>
                    <li>Resolució de casos.</li>
                    <li>Dinàmiques inspirades en l&apos;ISPC.</li>
                    <li>Situacions basades en experiències reals.</li>
                </ul>

                <p className="mt-5">
                    Cada sessió està pensada perquè t&apos;apropis una mica més
                    a la realitat que viuràs durant la teva etapa formativa.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="💻" label="campus virtual espai bulevard" />{" "}
                    Campus virtual exclusiu
                </h2>

                <p className="mt-5">
                    Des del moment de la matrícula tindràs accés al Campus Espai
                    Bulevard, disponible les 24 hores.
                </p>

                <p className="mt-5">Hi trobaràs:</p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>11 assignatures exclusives.</li>
                    <li>Materials actualitzats.</li>
                    <li>Recursos complementaris.</li>
                    <li>Documentació de suport.</li>
                    <li>Continguts accessibles sempre que els necessitis.</li>
                </ul>

                <p className="mt-5">
                    Tot el contingut està estructurat perquè reforcis el treball
                    realitzat a les sessions presencials.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji
                        symbol="🤝"
                        label="recursos acompanyament espai bulevard"
                    />{" "}
                    Recursos i acompanyament
                </h2>

                <p className="mt-5">
                    A més de la formació presencial i online, disposaràs de:
                </p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>Manual del Bulevard de butxaca.</li>
                    <li>Grup privat de WhatsApp.</li>
                    <li>Fòrum exclusiu de consultes.</li>
                    <li>Seguiment durant tota la preparació.</li>
                </ul>

                <p className="mt-5">
                    Perquè sabem que preparar aquesta etapa no consisteix només
                    en aprendre, sinó també en sentir-te acompanyat.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="👨‍🏫" label="professorat espai bulevard" />{" "}
                    Professorat
                </h2>

                <p className="mt-5">
                    Aprendràs de professionals que coneixen perfectament la
                    realitat policial.
                </p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        <Emoji symbol="👮" label="policies en actiu" /> Policies
                        en actiu.
                    </li>
                    <li>
                        <Emoji symbol="🎓" label="exinstructors de l'ISPC" />{" "}
                        Exinstructors de l&apos;ISPC.
                    </li>
                    <li>
                        <Emoji
                            symbol="📚"
                            label="professionals especialitzats seguretat pública"
                        />{" "}
                        Professionals especialitzats en diferents àrees de la
                        seguretat pública.
                    </li>
                </ul>

                <p className="mt-5">
                    Una combinació d&apos;experiència, coneixement i vocació al
                    servei de la teva preparació.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="📅" label="grups campus espai bulevard" />{" "}
                    Grups
                </h2>

                <p className="mt-5">
                    <strong>Grup 1:</strong>
                </p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>Dissabtes de 16:00 a 19:00 h.</li>
                    <li>Sessió 0 — Benvinguda: 18/07/2026.</li>
                    <li>05/09/2026.</li>
                    <li>12/09/2026.</li>
                    <li>19/09/2026.</li>
                    <li>26/09/2026.</li>
                    <li>03/10/2026.</li>
                    <li>10/10/2026.</li>
                    <li>17/10/2026.</li>
                    <li>24/10/2026.</li>
                </ul>

                <p className="mt-5">
                    <strong>Grup 2:</strong>
                </p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>Dissabtes de 19:00 a 22:00 h.</li>
                    <li>Sessió 0 — Benvinguda: 18/07/2026.</li>
                    <li>05/09/2026.</li>
                    <li>12/09/2026.</li>
                    <li>19/09/2026.</li>
                    <li>26/09/2026.</li>
                    <li>03/10/2026.</li>
                    <li>10/10/2026.</li>
                    <li>17/10/2026.</li>
                    <li>24/10/2026.</li>
                </ul>

                <p className="mt-5">
                    <strong>Grup 3:</strong>
                </p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>Diumenges de 16:00 a 19:00 h.</li>
                    <li>Sessió 0 — Benvinguda: 19/07/2026.</li>
                    <li>06/09/2026.</li>
                    <li>13/09/2026.</li>
                    <li>20/09/2026.</li>
                    <li>27/09/2026.</li>
                    <li>04/10/2026.</li>
                    <li>11/10/2026.</li>
                    <li>18/10/2026.</li>
                    <li>25/10/2026.</li>
                </ul>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="📍" label="ubicacio campus espai bulevard" />{" "}
                    Ubicació
                </h2>

                <p className="mt-5">Lynx — Sant Cugat del Vallès.</p>

                <p className="mt-5">
                    Més de 2.000 m² d&apos;instal·lacions preparades per
                    desenvolupar una formació pràctica, dinàmica i immersiva.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="💰" label="preu campus espai bulevard" />{" "}
                    Preu
                </h2>

                <p className="mt-5">
                    <strong>299,99 €</strong>
                </p>

                <p className="mt-5">Possibilitat de pagament fraccionat.</p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🔥" label="resum campus espai bulevard" /> En
                    resum
                </h2>

                <p className="mt-5">
                    L&apos;Espai Bulevard és molt més que un curs. És una
                    preparació pensada perquè arribis a l&apos;ISPC amb
                    coneixement, experiència i confiança.
                </p>

                <p className="mt-5">
                    <Emoji symbol="👉" label="arriba preparat ispc" /> Perquè la
                    diferència entre arribar i arribar preparat pot marcar tota
                    la teva etapa a l&apos;Escola de Policia.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji
                        symbol="🛡️"
                        label="garantia iopos campus espai bulevard"
                    />{" "}
                    Garantia iOpos
                </h2>

                <p className="mt-5">
                    Confiem tant en aquesta preparació que, si finalment no ets
                    apte abans d&apos;entrar a la 40a promoció, pots sol·licitar
                    la devolució del pagament i et retornarem íntegrament
                    l&apos;import abonat.
                </p>
            </section>
        );
    };

    return (
        <NewProductTemplate
            item={item}
            title="Prepara't avui per afrontar amb confiança el repte més important abans de començar la teva etapa a l'ISPC."
        >
            <Data />
        </NewProductTemplate>
    );
};

export default Product;
